export default class RoundSDK {
  constructor (http) {
    this.http = http
  }

  reorder (tournamentId, dto) {
    return this.http.post(`/round/re-order?tournamentId=${tournamentId}`, dto)
  }
}
